import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import { callApi, fnGetDataSet, fnSave } from "@shared/api/restApi";
import {
  getAutoSlip,
  getInitFormData, getNoSlip,
  getTablebySql,
} from "@shared/utils/CommonUtils";
import { global, globalMenu } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "src/widgets/CommonDialog";
import { showPopupModal } from "@widgets/CommonModal";
import SN_MTL_BAS_REG_008_POP_01 from "./SN_MTL_BAS_REG_008_POP_01";
import { parse, isValid } from "date-fns";
import { ProcessCellForExportParams } from "ag-grid-community";
import SnForm, { SnFormRef, ValueChangedEvent } from "@widgets/SnForm";
import {
  CellValueChangedEvent,
  SnGridRef,
} from "@shared/components/GridV2/SnGridTypes";
import SnResizeBar from "@shared/components/SnResizeBar";
import { dateToString } from "@shared/utils/DateUtils";

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_MTL_BAS_REG_008 = forwardRef(({ Menuprops }: Props, ref) => {
  const [gridColumns, setGridColumns] = useState<any[]>([]);
  const [dataSource1, setDataSource1] = useState<any[]>([]);

  const formRefs = useRef<{ [key: string]: React.RefObject<SnFormRef> }>({
    freeform1: React.createRef(),
  });

  const [formControls, setFormControls] = useState<any>({
    freeform1: [],
  });

  const [formDatas, setFormDatas] = useState<any>({
    freeform1: null,
  });

  const gridRefs = useRef<{ [key: string]: React.RefObject<SnGridRef> }>({
    grid1: React.createRef(),
  });

  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1).toString().padStart(2, "0")}`;
  const todayToString = dateToString(today);

  const { userInfo } = global();
  const [gridFocus, setGridFocus] = useState(false);

  const onValueChaged = async (event: ValueChangedEvent) => {
    if (!event) return;
  };

  const forms = useMemo(
      () => ({
        freeform1: {
          controls: formControls.freeform1,
          data: formDatas.freeform1,
          etcProps: {},
          events: {
            onValueChanged: onValueChaged,
          },
        },
      }),
      [formControls, formDatas]
  );

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControls({
          freeform1: rtn.form.freeform1,
        });
        setGridColumns(rtn.grid.grid1);
      } catch (error) {}
    };
    fetchform();
  }, []);
  useEffect(() => {
    getGridCurrent("grid1").selectAndFocusRow(0);
    setGridFocus(false);
  }, [gridFocus]);
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
    onPrint,
  }));

  const getGridCurrent = (key: string): SnGridRef => {
    const grid = gridRefs.current[key]?.current;
    if (!grid) {
      throw new Error(`Grid '${key}' is not mounted yet`);
    }
    return grid;
  };

  const getFormCurrent = (key: string): SnFormRef => {
    const form = formRefs.current[key]?.current;
    if (!form) {
      throw new Error(`Grid '${key}' is not mounted yet`);
    }
    return form;
  };

  const onSearch = async () => {
    await search_popup();
  };

  const search_popup = async () => {
    const modifiedRowsH = getFormCurrent("freeform1").getChange();
    const modifiedRowsL = getGridCurrent("grid1").getChange();

    if (
        modifiedRowsH.modifiedRowcount > 0 ||
        modifiedRowsL.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
          "confirm",
          "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        const isSaved: any = await onSave();
        if (!isSaved) return;
      }
    }

    const selectedData = await getPopupInitialData();
    const component = <SN_MTL_BAS_REG_008_POP_01 selectedData={selectedData} />;
    const result = await showPopupModal({
      title: "자재바코드발행2 조회",
      children: component,
      validation: true,
    });

    if (!result || result === "close") return;

    await searchData(result || {});

    await getFormCurrent("freeform1").setDataValue("no_bsn", result[0].no_bsn);
    await getFormCurrent("freeform1").setDataValue("ym", result[0].ym);
    getFormCurrent("freeform1").resetUpdate();
  };

  const searchData = async (searchParams: any = {}) => {
    try {
      const params = {
        id: "sn_mtl_bas_reg_008_01",
        params: {
          cd_firm: userInfo.cd_firm,
          ym: searchParams[0].ym,
          no_bsn: searchParams[0].no_bsn,
        },
      };

      setDataSource1([]);
      const data: any = await fnGetDataSet(params);
      setDataSource1(data[0]);
      if (data[0] && data[0].length > 0) {
        await new Promise((resolve) => setTimeout(resolve, 50));

        setGridFocus(true);
      }

      getGridCurrent("grid1").resetUpdate();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const getPopupInitialData = async () => {
    const selectedRows = getGridCurrent("grid1").getSelectedRows?.() || [];
    const selectedRow = selectedRows[0] || {};

    return {
      dt_from: selectedRow.ym || todayform,
      dt_to: selectedRow.ym || todayform,
      no_bsn: selectedRow.no_bsn || "",
    };
  };

  //#region onInsert
  const onInsert = async () => {
    try {
      const modifiedRowsH = getFormCurrent("freeform1").getChange();
      if (modifiedRowsH.modifiedRowcount > 0) {
        const confirm = await showDialog(
            "confirm",
            "수정중인 건이 있습니다. 저장하지 않고 계속 하시겠습니까?"
        );
        if (!confirm) return;
      }

      getFormCurrent("freeform1").resetUpdate();
      setDataSource1([]);
      getGridCurrent("grid1").resetUpdate();

      const newRow = {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        ym: todayToString,
        no_bsn: formDatas.no_bsn,
      };
      getFormCurrent("freeform1").addRow(newRow);
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  //#region onDelete
  const onDelete = async () => {
    if (!getFormCurrent("freeform1").checkDataExist()) return;

    const freeform = getFormCurrent("freeform1");
    const grid = getGridCurrent("grid1");
    const formData = freeform.getFormdata();

    const cdFirm = String(formData?.cd_firm ?? userInfo.cd_firm ?? "").trim();
    const noBsn = String(formData?.no_bsn ?? "").trim();

    if (!cdFirm || !noBsn) {
      await showDialog("alter", "삭제할 발행번호가 없습니다.");
      return;
    }

    const rows = ((grid as any).getRowData?.() ?? dataSource1 ?? []) as any[];
    const deleteRows = rows.filter(
        (row) =>
            row?.state !== "insert" &&
            String(row?.cd_firm ?? "").trim() === cdFirm &&
            String(row?.no_bsn ?? "").trim() === noBsn
    );

    const confirm = await showDialog("confirm", "삭제하시겠습니까?");
    if (!confirm) return;

    const ok = await fnSave("SN_MTL_BAS_REG_008_SAVE_01", {
      mas_bsn_list: {
        delete: deleteRows,
      },
    });

    if (!ok) return false;

    freeform.deleteForm();
    setDataSource1([]);
    grid.resetUpdate();
  };

  //#region onSave
  const onSave = async () => {
    try {
      const grid = getGridCurrent("grid1");
      grid.stopEditing();
      await new Promise((resolve) => setTimeout(resolve, 0));

      const requiredValuesCheck = grid.requiredValuesCheck();
      if (!requiredValuesCheck) return false;

      const masBsnListChanges = grid.getChange();
      if (masBsnListChanges.modifiedRowcount < 1) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return false;
      }

      const form = getFormCurrent("freeform1");
      const formData = form.getFormdata();
      const insertRows = masBsnListChanges.insert ?? [];
      let noBsn = String(formData?.no_bsn ?? "").trim();
      let isNewNoBsn = false;

      // 상단에 발행번호가 없는 최초 등록 건만 신규 채번한다.
      if (insertRows.length > 0 && !noBsn) {
        try {
          const generatedNoBsn = await getAutoSlip(
              "MAS",
              10,
              insertRows[0].ym,
              Menuprops.cd_menu || "SN_MTL_BAS_REG_008"
          );
          noBsn = generatedNoBsn ?? "";
          isNewNoBsn = Boolean(noBsn);
        } catch (error: any) {}
      }

      // 신규 채번한 발행번호에 대해서만 중복 여부를 확인한다.
      if (isNewNoBsn) {
        const result = await callApi("SN_MTL_BAS_REG_008_checkNoBsn", {
          cd_firm: insertRows[0]?.cd_firm ?? userInfo.cd_firm,
          no_bsn: noBsn,
        });

        if (result?.data?.no_bsn) {
          await showDialog("alter", "발행번호가 중복됩니다.");
          return false;
        }

        await form.setDataValue("no_bsn", noBsn, "noEvent");
      }

      // 기존 발행번호 또는 이번에 채번한 발행번호를 신규 상세 행에 승계한다.
      for (const row of insertRows) {
        if (noBsn) row.no_bsn = noBsn;
        if (!row.no_bsn) continue;
        if (!row.no_barcode) {
          try {
            const no_barcode = await getNoSlip(
                "MAS",
                15,
                'BAR',
                row.ym,
                Menuprops.cd_menu || "SN_MTL_BAS_REG_008"
            );
            if (no_barcode) row.no_barcode = no_barcode;
          } catch (error: any) {}
        }

        if (!row.no_barcode) continue;
      }

      const saveData = {
        mas_bsn_list: masBsnListChanges,
      };

      const ok = await fnSave("SN_MTL_BAS_REG_008_SAVE_01", saveData);
      if (!ok) {
        grid.resetUpdate(true);
        return false;
      }

      grid.resetUpdate();
      form.resetUpdate();
      return true;
    } catch (error: any) {
      getGridCurrent("grid1").resetUpdate(true);
      return false;
    }
  };

  //#region onPrint
  const setPrintFlag = async (rows: any[], yn_print: "Y" | "N") => {
    await Promise.all(
        rows.map((row) =>
            getTablebySql({
              sql: `update mas_bsn_list
                    set yn_print = :yn_print
                    where cd_firm = :cd_firm
                      and cd_item = :cd_item
                      and no_barcode = :no_barcode
                      and no_bsn = :no_bsn
                      and cd_bsn = :cd_bsn`,
              yn_print: yn_print,
              cd_firm: userInfo.cd_firm,
              cd_item: row.cd_item,
              no_barcode: row.no_barcode,
              no_bsn: row.no_bsn,
              cd_bsn: row.cd_bsn || "ITEM",
            })
        )
    );
  };

  const resetPrintFlagLater = (rows: any[]) => {
    window.setTimeout(() => {
      setPrintFlag(rows, "N");
    }, 3000);
  };

  const onPrint = async () => {
    const grid = getGridCurrent("grid1");
    grid.stopEditing();

    const checkedRows = grid.getCheckedRows?.() || grid.getSelectedRows() || [];
    if (checkedRows.length < 1) {
      await showDialog("alter", "선택된 정보가 없습니다.");
      return false;
    }

    const invalidRow = checkedRows.find(
        (row) => Number(row.qt ?? 0) < 1 || Number(row.qt_print ?? 0) < 1
    );
    if (invalidRow) {
      await showDialog(
          "alter",
          "매입량과 출력수량은 최소 1 이상이어야 출력이 가능합니다."
      );
      return false;
    }

    const firstRow = checkedRows[0];
    await setPrintFlag(checkedRows, "Y");
    resetPrintFlagLater([...checkedRows]);

    return {
      cd_firm: userInfo.cd_firm,
      no_bsn: firstRow.no_bsn,
      ym: firstRow.ym,
      cd_biz: firstRow.cd_biz,
      yn_print: "Y",
    };
  };
  //#endregion

  //#region GridButton
  const onGrid1BtnsClick = async (id: string) => {
    switch (id) {
      case "addRow":
        onAddRow();
        break;
      case "deleteRow":
        onDeleteRow();
        break;
    }
  };

  const onAddRow = async () => {
    try {
      const formData = getFormCurrent("freeform1").getFormdata();
      if (!formData?.ym) {
        await showDialog("alter", "상단 내용을 먼저 입력해주시기 바랍니다.");
        return false;
      }

      const newRow = {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        ym: formData.ym ?? dateToString(new Date()),
        no_bsn: formData.no_bsn,
        cd_bsn: "ITEM",
      };
      return getGridCurrent("grid1").addRow(newRow);
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onDeleteRow = () => {
    getGridCurrent("grid1").deleteSelectedRows();
  };
  //#region CellChanged
  const onCellValueChanged = async (event: any) => {
    if (!event) return;
  };

  const gridEtcProps = useMemo(
      () => ({
        rowSelection: "multiple" as const,
        ischeckboxSelection: true,
        title: "상세정보",
        isEditable: true,
      }),
      []
  );

  const gridEvents = useMemo(
      () => ({
        onBtnAddClick: onGrid1BtnsClick,
        onBtnDeleteClick: onGrid1BtnsClick,
        onCellValueChanged: onCellValueChanged,
      }),
      []
  );
  //#region othersMethod

  function tryParseExact(dateStr: string, formats: string[]): Date | null {
    for (const format of formats) {
      const parsed = parse(dateStr, format, new Date());
      if (isValid(parsed)) {
        return parsed;
      }
    }
    return null;
  }

  //#region UI
  return (
      <div className="h-full flex flex-col">
        <div className="flex-1 h-full min-h-0 space-y-1.5">
          <SnResizeBar direction={"height"} id="panel1" orgSize="6.5%">
            <div className="h-full min-h-0">
              <SnForm
                  ref={formRefs.current["freeform1"]}
                  controls={forms.freeform1.controls}
                  data={forms.freeform1.data}
                  events={forms.freeform1.events}
              ></SnForm>
            </div>
          </SnResizeBar>
          <SnResizeBar direction={"height"} id="panel2" orgSize="92%">
            <div className="h-full min-h-0">
              <SnGrid
                  ref={gridRefs.current["grid1"]}
                  columnConfig={gridColumns}
                  rowData={dataSource1}
                  etcProps={gridEtcProps}
                  events={gridEvents}
              />
            </div>
          </SnResizeBar>
        </div>
      </div>
  );
});
export default SN_MTL_BAS_REG_008;
